import {
  type SimpleShowResPagedData,
  type SiteShowSummaryResPagedData,
  sitesV1NationalShowsList,
  sitesV1SiteShowSummaryList,
} from '@on3/api';
import type { IGenericPageProps } from '@on3/ui-lib/api/schema/custom-contracts';
import withAuthentication from '@on3/ui-lib/src/hocs/withAuthentication';
import withValidUrl from '@on3/ui-lib/src/hocs/withValidUrl';
import { getFulfilledValue, proxyApi } from '@on3/ui-lib/utils/api';
import { AdSidebarLayout } from 'components/Layouts/AdSidebarLayout';
import { PageWrapper } from 'components/Layouts/PageWrapper';
import { ShowsIndex } from 'components/Shows/ShowsIndex';
import type { GetServerSideProps } from 'next';

export interface IShowsIndexProps extends IGenericPageProps {
  nationalList?: SimpleShowResPagedData;
  collegeList?: SiteShowSummaryResPagedData;
  title?: string;
}

const ShowsListPage = ({
  siteData,
  nationalList,
  collegeList,
  ...props
}: IShowsIndexProps) => {
  const description =
    'Explore the On3 Podcast & Shows Network featuring national and college team-specific podcasts. Get the latest insights and updates from hosts covering teams like Alabama, Florida, Georgia, and more. Stay informed with shows like Andy Staples, Wiltfong Whiparound, and various college teams’ podcasts hosted by dedicated sites.';
  const title = 'On3 Podcast & Shows Network';

  return (
    <PageWrapper
      {...props}
      description={description}
      siteData={siteData}
      title={title}
    >
      <AdSidebarLayout>
        <ShowsIndex
          collegeList={collegeList}
          nationalList={nationalList}
          title={title}
        />
      </AdSidebarLayout>
    </PageWrapper>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const siteData = await withValidUrl.isValid(ctx);
  const userData = await withAuthentication.isAuth(ctx);

  if (!siteData) {
    return {
      notFound: true,
    };
  }

  try {
    const [nationalList, collegeList] = await Promise.allSettled([
      sitesV1NationalShowsList(proxyApi, {}),
      sitesV1SiteShowSummaryList(proxyApi, {}),
    ]);

    const data = {
      pageType: 'shows',
      siteData,
      userData: userData || {},
      nationalList: getFulfilledValue(nationalList),
      collegeList: getFulfilledValue(collegeList),
    };

    return { props: { ...data } };
  } catch (e) {
    return { props: [] };
  }
};

export default withValidUrl(ShowsListPage);
